import React from "react";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { faSitemap } from "@fortawesome/pro-solid-svg-icons";
import { DefaultIconStyle } from "./styles";

export function IconSitemap(props: Partial<FontAwesomeIconProps>): React.ReactElement {
  return <FontAwesomeIcon style={DefaultIconStyle} {...props} icon={faSitemap} />;
}
